import moment from 'moment';
import { has } from 'lodash';

export const dateFormat = 'll';
export const dateTimeFormat = 'lll z';
export const timeFormat = 'LT z';

export const getTimeZoneOptions = () => moment.tz.names().map(tz => ({
  label: tz,
  value: tz
}));

export const formatDate = (date, activeLanguage, timezone) => {
  const langCode = has(activeLanguage, 'code') ? activeLanguage.code : 'en';

  let momentObj = moment(date);
  if (timezone) { momentObj = momentObj.tz(timezone || 'UTC'); }

  return momentObj.locale(langCode).format(dateFormat);
};

export const formatDateTime = (date, activeLanguage, timezone) => {
  const langCode = has(activeLanguage, 'code') ? activeLanguage.code : 'en';

  let momentObj = moment(date);
  if (timezone) { momentObj = momentObj.tz(timezone || 'UTC'); }

  return momentObj.locale(langCode).format(dateTimeFormat);
};

export const formatDateTimeFromNow = (date, activeLanguage) => {
  const langCode = has(activeLanguage, 'code') ? activeLanguage.code : 'en';

  const momentObj = moment(date);

  return momentObj.locale(langCode).fromNow();
};



// WEBPACK FOOTER //
// ./src/components/common/datetime.js